export default "__VITE_ASSET__DZm8T3QO__"